import {
  IconCode,
  IconPalette,
  IconBulb,
  IconUsers,
  IconTrendingUp,
} from "@tabler/icons-react";
import React from "react";

export const getProjectIcon = (projectType: string): React.ReactNode => {
  switch (projectType) {
    case "Technical Development":
      return <IconCode size={20} />;
    case "Digital Media":
      return <IconPalette size={20} />;
    case "Teaching & Events":
      return <IconUsers size={20} />;
    case "Marketing & Strategy":
      return <IconTrendingUp size={20} />;
    default:
      return <IconBulb size={20} />;
  }
};

export const getProjectGradient = (projectType: string): string => {
  switch (projectType) {
    case "Technical Development":
      return "linear-gradient(135deg, rgba(249,115,22,0.8) 0%, rgba(234,88,12,0.8) 100%)";
    case "Digital Media":
      return "linear-gradient(135deg, rgba(168,85,247,0.8) 0%, rgba(147,51,234,0.8) 100%)";
    case "Marketing & Strategy":
      return "linear-gradient(135deg, rgba(34,197,94,0.8) 0%, rgba(21,128,61,0.8) 100%)";
    case "Teaching & Events":
      return "linear-gradient(135deg, rgba(59,130,246,0.8) 0%, rgba(37,99,235,0.8) 100%)";
    default:
      return "linear-gradient(135deg, rgba(249,115,22,0.8) 0%, rgba(234,88,12,0.8) 100%)";
  }
};
